import { PAGES } from "@dune/types";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { attachToken } from "../api/axios";
import { useMe } from "../api/queries/users.queries";
import { usersQueryKeys } from "../api/query-keys/users.query-keys";
import { AppLayout } from "../component/common/AppLayout";
import { useAuthStore } from "../stores/auth.store";

export const InternalAppWrapper = () => {
	const navigate = useNavigate();
	const logout = useAuthStore((state) => state.logout);
	const impersonationToken = useAuthStore((state) => state.impersonationToken);
	const accessToken = useAuthStore((state) => state.accessToken);
	const setImpersonationToken = useAuthStore(
		(state) => state.setImpersonationToken,
	);
	const queryClient = useQueryClient();

	const { me } = useMe();

	const hangleLogout = () => {
		logout();
		navigate(PAGES.LOGIN);
	};

	return (
		<AppLayout
			onLogout={hangleLogout}
			userConnected={me}
			showImpersonationBanner={!!impersonationToken}
			onImpersonationLogout={() => {
				setImpersonationToken(null);
				if (accessToken) {
					attachToken(accessToken);
					queryClient.refetchQueries({
						queryKey: usersQueryKeys.me(),
					});
					navigate(PAGES.CONTACTS.index);
				} else {
					hangleLogout();
				}
			}}
		/>
	);
};
